import React from 'react';
import { useParams } from 'react-router';

import { useGetVariantCommentsQuery } from '../../api/variantApi';
import CollapsePanel from '../components/CollapsePanel';
import VariantCommentsTable from './VariantCommentsTable';

const VariantComments = () => {
  const params = useParams();
  // Read comments straight from the query hook's cache rather than a selector
  const { data: variantComments } = useGetVariantCommentsQuery(
    { variant_id: params.vid },
    { skip: !params.vid },
  );

  if (!variantComments || variantComments.length === 0) {
    return null; // Do not render anything if there's no comments
  }

  return (
    <CollapsePanel
      title={<h3 className="c-collapse-title">Comments</h3>}
      panelKey="variant_comments"
      defaultActiveKey="variant_comments"
    >
      <VariantCommentsTable />
    </CollapsePanel>
  );
};

export default VariantComments;
